export enum PromptVersion {
	COUNTRY = 'country',
	COUNTRY_CHAT = 'country-chat',
	ARTICLE_IVY_LEAGUE = 'article-ivy-league',
	COUNTRY_CHAT_V2 = 'country-chat-v2',
	ARTICLE_IVY_LEAGUE_V2 = 'article-ivy-league-v2',
	LANDING_PAGE = 'landing-page-v1',
	SEARCH_PAGE = 'search-page-v1',
}
